import { css } from "styled-components";

export const TableStyles = css(({ theme }) => ({
    ".TableRoot": {
        "&&": {
            border: "none",
            "--table-border-color": theme.palette.gray[100],
            ".TableContainer": {
                border: "var(--table-border)",
                borderBottom: "none",
                borderRadius: theme.borderRadius,
            },
            ".TableHead": {
                ".TableHeader": {
                    ...theme.typography.body2Strong.style,
                },
            },
            ".TableBody": {
                ...theme.typography.body2Regular.style,
            },
            ".TableFooter": {
                borderTop: "none",
                padding: theme.spacing.vertical(6),
            },
            ".TableRow": {
                ":last-child": {
                    ".TableCell": {
                        ":last-child": {
                            borderBottomRightRadius: theme.borderRadius,
                        },
                        ":first-child": {
                            borderBottomLeftRadius: theme.borderRadius,
                        },
                    },
                },
            },
        },
    },
}));
